import { render, staticRenderFns } from "./OtpLockoutTimer.vue?vue&type=template&id=0c8a37a2&scoped=true"
import script from "./OtpLockoutTimer.vue?vue&type=script&lang=js"
export * from "./OtpLockoutTimer.vue?vue&type=script&lang=js"
import style0 from "./OtpLockoutTimer.vue?vue&type=style&index=0&id=0c8a37a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a37a2",
  null
  
)

export default component.exports